import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { useEffect } from "react";
import UserStore from "../../../store/UserStore";
import { getCardPercentage } from "../../../utils/functions";
import useWindowDimensions from "../../../utils/useWindowDimensions";
import EmblaCarousel from "../../../components/Carousal/EmblaCarousal";
import { movePer } from "../../../utils/constants";
import {
  NextButton,
  PrevButton,
  usePrevNextButtons,
} from "../../../components/Carousal/EmblaCarouselArrowButtons";
import useEmblaCarousel from "embla-carousel-react";

const OPTIONS = { align: "start", loop: true };

const NavigationCorousal = () => {
  const [emblaRef, emblaApi] = useEmblaCarousel(OPTIONS);
  const [currentCardsIndex, setCurrentCardsIndex] = useState(3);
  const [snippetsCards, setSnippetsCards] = useState([]);
  const [cardWidth, setCardWidth] = useState(320);
  const [movementPercentage, setmovementPercentage] = useState(movePer);
  const { width } = useWindowDimensions();

  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  } = usePrevNextButtons(emblaApi);

  useEffect(() => {
    const storeCards = UserStore.snippets?.data;

    if (storeCards?.length) {
      setSnippetsCards(
        storeCards.length !== 5 ? storeCards : storeCards.concat(storeCards)
      );
      //setSnippetsCards(storeCards);
    }
  }, [UserStore.snippets?.data]);

  useEffect(() => {
    const isMaxWidth = width >= 1440;
    const cardInfo =
      width > 1100
        ? { numberOfCards: 4, extraSpace: 160 }
        : { numberOfCards: 3, extraSpace: 120 };
    const { numberOfCards: numOfCards, extraSpace } = cardInfo;
    setCardWidth(isMaxWidth ? 320 : (width - 160) / numOfCards);
    setmovementPercentage(
      isMaxWidth
        ? movePer
        : getCardPercentage({
            width,
            numOfCards,
            extraSpace,
            margin: 25,
          })
    );
  }, [width]);

  return (
    <>
      {snippetsCards.length >= 5 ? (
        <>
          <div className="embla_nav">
            <div className="embla_nav__container">
              <div className="headerCorousal">
                <h2 className="home_title">Portfolio Insights</h2>
                <div className="filter-bar"></div>
              </div>
              {/* 1.In analytics there is only irr text available , here
                    isDisplayIrr is undefined and when we have to show
                    absolute_return value then isDisplayIrr is false but in
                    above case we will give preference to absolute_return else
                    we display irr
                    2.isDisplayIrr will be true in case when we aim to show irr
                    so the preference is irr here else we display absolute_return

                  order of displying cards is
                  absolute_return performance || analytics card || irr performance || repeat */}
              <EmblaCarousel
                slides={snippetsCards}
                // options={OPTIONS}
                cardInPx={cardWidth}
                cardWidth={movementPercentage}
                ref={emblaRef}
                currentCardsIndex={currentCardsIndex}
              />
            </div>

            <div className="nav-movement1">
              <div className="rightBtn">
                <PrevButton
                  class="custom_view_all backBtn"
                  onClick={() => {
                    setCurrentCardsIndex((prev) =>
                      prev !== 0 ? prev - 1 : snippetsCards.length - 1
                    );
                    onPrevButtonClick();
                  }}
                  disabled={prevBtnDisabled}
                  aria-label={"Previous"}
                />
              </div>
              <div className="leftBtn">
                <NextButton
                  class="custom_view_all"
                  onClick={() => {
                    setCurrentCardsIndex((prev) =>
                      prev !== snippetsCards.length - 1 ? prev + 1 : 0
                    );
                    onNextButtonClick();
                  }}
                  disabled={nextBtnDisabled}
                  aria-label={"Next"}
                />
              </div>
            </div>
          </div>
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default observer(NavigationCorousal);
